export function generateUrlWithParams(uri: string = '', params: {[key: string]: string | number | boolean | null | undefined}): string {
    let urlWithParams = uri;
    const queryParams = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${key}=${encodeURIComponent((value as string | number | boolean).toString())}`)
        .join('&');

    if (queryParams) {
        urlWithParams += `?${queryParams}`;
    }

    return urlWithParams;
}